import { ReactNode } from 'react';

import { Chip } from '@braskai/ui-kit';
import { useNavigate } from 'react-router-dom';

import {  ListItemIcon, ListItemProps } from '@mui/material';

import { SListItem, SListItemButton, SListItemText } from './styled';

export type NavigationItemProps = {
  title?: string;
  dataTestId?: string;
  icon?: ReactNode;
  isDisabled?: boolean;
  isMainMenu?: boolean;
  isMobile?: boolean;
  isSquare?: boolean;
  path?: string;
  rightText?: string;
  selected?: boolean;
  tag?: ReactNode | string;
  onClick?: () => void;
} & ListItemProps;

export const NavigationItem = ({
  title,
  dataTestId,
  icon,
  isDisabled = false,
  isMainMenu,
  isMobile = false,
  isSquare = false,
  path,
  rightText,
  selected = false,
  tag,
  onClick,
  ...props
}: NavigationItemProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (path) {
      navigate(path);
    }

    onClick?.();
  };

  return (
    <SListItem key={path} disablePadding {...props}>
      <SListItemButton
        $isDisabled={isDisabled}
        $isMainMenu={isMainMenu}
        $isMobile={isMobile}
        $isSquare={isSquare}
        data-testid={dataTestId}selected={selected}
        onClick={handleClick}
      >
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        {title && <SListItemText primary={title} secondary={rightText} />}
        {tag && <Chip label={tag} color="primary" size="md"/>}
      </SListItemButton>
    </SListItem>
  );
};
